<nz-modal [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="850" nzCentered
    [nzVisible]="isVisibleEditVendor" [nzTitle]="'Edit Vendor Details'" [nzFooter]="null" (nzOnCancel)="handleCancel(null)">
    <ng-container *nzModalContent>
        <app-add-vendor-form [isEditVendor]="true" [currentVendorData]="currentVendorData" (hideEditVendor)="handleCancel($event)"></app-add-vendor-form>
    </ng-container>
</nz-modal>